const configDe = {
  page: "Abschnitt-",
  question: "Frage-",
  columns: "Spalten-",
  rows: "Zeilen-",
  choices: "Option-",
  copy: "(Kopie)"
};
export default configDe;
